import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/location_icon.svg'
import _imports_1 from '../../assets/telephone_icon.svg'
import _imports_2 from '../../assets/fax-icon.svg'
import _imports_3 from '../../assets/mail-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-1ec137ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col hd:flex-row max-w-body-width pb-lg w-body-width mx-auto mb-xl hd:mb-4xl" }
const _hoisted_2 = { class: "mt-2xl hd:mt-0 hd:w-1/3 hd:mr-xl contact-details order-2 hd:order-none" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<h2 class=\"mb-xl ml-0 has-larger-font-size\" data-v-1ec137ba>Kontaktinformation</h2><p class=\"mb-xl text-center hd:text-left\" data-v-1ec137ba> Einfach das Kontaktformular ausfüllen, unser Support-Team wird sich bald bei Ihnen melden. </p><p class=\"text-accent tex-center hd:text-left has-large-font-size mb-lg\" data-v-1ec137ba> netconnect AG </p><div class=\"flex mb-standard ml-xl hd:ml-0\" data-v-1ec137ba><div class=\"icon-container\" data-v-1ec137ba><img src=\"" + _imports_0 + "\" class=\"footer-icon\" data-v-1ec137ba></div><p data-v-1ec137ba>Industriestrasse 26<br data-v-1ec137ba>8404 Winterthur, Schweiz</p></div>", 4)
const _hoisted_7 = {
  key: 0,
  class: "flex"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "footer-icon"
  })
], -1))
const _hoisted_9 = {
  key: 1,
  class: "flex"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "footer-icon"
  })
], -1))
const _hoisted_11 = {
  key: 2,
  class: "flex"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    class: "footer-icon"
  })
], -1))
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-xl ml-0 has-larger-font-size" }, " Senden sie uns eine Nachricht ", -1))
const _hoisted_15 = { class: "flex flex-col hd:flex-row justify-between pb-standard" }
const _hoisted_16 = { class: "flex flex-col flex-half-margin" }
const _hoisted_17 = { class: "flex flex-col flex-half-margin" }
const _hoisted_18 = { class: "flex flex-col hd:flex-row justify-between pb-standard" }
const _hoisted_19 = { class: "flex flex-col flex-half-margin" }
const _hoisted_20 = { class: "flex flex-col flex-half-margin" }
const _hoisted_21 = { class: "flex flex-col hd:flex-row justify-between pb-standard" }
const _hoisted_22 = { class: "flex flex-col flex-half-margin" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "flex-quarter my-auto text-left",
  for: "category"
}, "Kategorie", -1))
const _hoisted_24 = ["disabled"]
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "flex flex-col flex-half-margin" }
const _hoisted_27 = { class: "flex flex-col hd:flex-row pb-standard justify-between" }
const _hoisted_28 = { class: "flex flex-col w-full" }
const _hoisted_29 = { class: "flex flex-col pb-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputControl = _resolveComponent("InputControl")!
  const _component_ButtonControl = _resolveComponent("ButtonControl")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.contactItems, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["flex flex-col ml-xl hd:ml-0", { 'mb-md': index < $setup.contactItems.length - 1 }]),
          key: item.ID
        }, [
          (item.acf.phone)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("p", null, "Tel: " + _toDisplayString(item.acf.phone), 1)
              ]))
            : _createCommentVNode("", true),
          (item.acf.fax)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("p", null, "Fax: " + _toDisplayString(item.acf.fax), 1)
              ]))
            : _createCommentVNode("", true),
          (item.acf.email)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                (item.acf.email)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: `mailto:${item.acf.email}`
                    }, _toDisplayString(item.acf.email), 9, _hoisted_13))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ]),
    _createElementVNode("form", {
      class: "flex flex-grow flex-col order-1 hd:order-none",
      onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => ($setup.onSend && $setup.onSend(...args)), ["prevent"]))
    }, [
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_InputControl, {
            name: "Kundennummer",
            modelValue: $setup.customerNumber,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.customerNumber) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_InputControl, {
            name: "Firmenname",
            modelValue: $setup.companyName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.companyName) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_InputControl, {
            name: "Vorname",
            modelValue: $setup.name,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.name) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_InputControl, {
            name: "Nachname",
            modelValue: $setup.surname,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.surname) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _withDirectives(_createElementVNode("select", {
            class: "flex-grow p-2 bg-background-light shadow-inset-sharp",
            type: "text",
            id: "category",
            disabled: $setup.categoryDisabled,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.category) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.contactFormCategories, (option) => {
              return (_openBlock(), _createElementBlock("option", {
                key: `cat-${option}`,
                value: option
              }, _toDisplayString(option), 9, _hoisted_25))
            }), 128))
          ], 8, _hoisted_24), [
            [_vModelSelect, $setup.category]
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_InputControl, {
            name: "Email",
            modelValue: $setup.email,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.email) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_InputControl, {
            name: "Betreff",
            modelValue: $setup.subject,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.subject) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createVNode(_component_InputControl, {
          name: "Nachricht",
          type: "textarea",
          modelValue: $setup.message,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.message) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(_component_ButtonControl, {
        class: "mt-xl hd:ml-auto hd:mr-0",
        label: "Senden",
        disabled: $setup.messageSent || !$setup.formFilled
      }, null, 8, ["disabled"])
    ], 32)
  ]))
}